export default (ics, fileName) => {
  const fileURL = `data:text/calendar;charset=utf8,${encodeURI(ics)}`;
  const anchor = document.createElement("a");
  document.body.appendChild(anchor);
  anchor.href = fileURL;
  anchor.download = fileName;
  anchor.click();
  document.body.removeChild(anchor);
};
